import script from "./PZ30.vue?vue&type=script&setup=true&lang=js"
export * from "./PZ30.vue?vue&type=script&setup=true&lang=js"

import "./PZ30.vue?vue&type=style&index=0&id=31cad99e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31cad99e"]])

export default __exports__